import { render, staticRenderFns } from "./WorkshopsParticipants.vue?vue&type=template&id=f5431d2c&scoped=true&"
import script from "./WorkshopsParticipants.vue?vue&type=script&lang=ts&"
export * from "./WorkshopsParticipants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5431d2c",
  null
  
)

export default component.exports